import { HugeiconsIcon } from "@hugeicons/react";
import type { IconSvgElement } from "@hugeicons/react";

import { CenterDots } from "@/components/ui/decorative-patterns";
import { cn } from "@/lib/utils";

/**
 * Empty state — centred icon chip, title, description and optional action on
 * the house centred-dot fade. Use for full-card empties (no results, first
 * run) so they read as designed surfaces, not blank cards.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: IconSvgElement;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "relative flex flex-col items-center overflow-hidden rounded-xl border border-border/60 bg-card px-6 py-12 text-center",
        className,
      )}
    >
      <CenterDots />
      <div className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary ring-1 ring-primary/15">
        <HugeiconsIcon icon={Icon} size={20} />
      </div>
      <h3 className="font-heading relative mt-4 text-base font-semibold">{title}</h3>
      {description && (
        <p className="relative mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="relative mt-5">{action}</div>}
    </div>
  );
}
